export var TrafficSource;
(function (TrafficSource) {
    TrafficSource["GOOGLE"] = "GOOGLE";
    TrafficSource["YANDEX"] = "YANDEX";
    TrafficSource["YOUTUBE"] = "YOUTUBE";
    TrafficSource["BING"] = "BING";
    TrafficSource["FACEBOOK"] = "FACEBOOK";
    TrafficSource["DUCKDUCKGO"] = "DUCKDUCKGO";
    TrafficSource["MAIL_RU"] = "MAIL_RU";
    TrafficSource["YAHOO"] = "YAHOO";
    TrafficSource["INSTAGRAM"] = "INSTAGRAM";
    TrafficSource["MSN"] = "MSN";
    TrafficSource["VK"] = "VK";
})(TrafficSource || (TrafficSource = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["TABLET"] = "TABLET";
})(DeviceType || (DeviceType = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["UPLOADED"] = "UPLOADED";
    FileStatus["PROCESSING_ATTEMPT"] = "PROCESSING_ATTEMPT";
    FileStatus["PROCESSED"] = "PROCESSED";
    FileStatus["PROCESSED_REPEATEDLY"] = "PROCESSED_REPEATEDLY";
    FileStatus["ERROR_UPLOADING"] = "ERROR_UPLOADING";
    FileStatus["ERROR_PROCESSING"] = "ERROR_PROCESSING";
    FileStatus["ERROR_DOWNLOADING"] = "ERROR_DOWNLOADING";
})(FileStatus || (FileStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["SUCCESSFUL"] = "SUCCESSFUL";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["REQUIRES_CAPTURE"] = "REQUIRES_CAPTURE";
})(PaymentStatus || (PaymentStatus = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["FREE"] = "FREE";
    SubscriptionType["TRIAL"] = "TRIAL";
    SubscriptionType["MONTHLY"] = "MONTHLY";
    SubscriptionType["YEARLY"] = "YEARLY";
})(SubscriptionType || (SubscriptionType = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["CARD"] = "CARD";
    PaymentType["PAYPAL"] = "PAYPAL";
})(PaymentType || (PaymentType = {}));
export var FileAssetType;
(function (FileAssetType) {
    FileAssetType["SIGNATURE"] = "SIGNATURE";
    FileAssetType["IMAGE"] = "IMAGE";
    FileAssetType["DRAWING"] = "DRAWING";
})(FileAssetType || (FileAssetType = {}));
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "STRIPE";
    PaymentProvider["DODO_PAYMENTS"] = "DODO_PAYMENTS";
    PaymentProvider["PADDLE"] = "PADDLE";
})(PaymentProvider || (PaymentProvider = {}));
export var UserEventType;
(function (UserEventType) {
    UserEventType["GUEST_ID_ASSIGNED"] = "GUEST_ID_ASSIGNED";
    UserEventType["USER_SIGN_IN"] = "USER_SIGN_IN";
    UserEventType["USER_SIGN_IN_ERROR"] = "USER_SIGN_IN_ERROR";
    UserEventType["USER_SIGN_UP"] = "USER_SIGN_UP";
    UserEventType["USER_SIGN_UP_ERROR"] = "USER_SIGN_UP_ERROR";
    UserEventType["SUBSCRIPTION_MODAL_OPENED"] = "SUBSCRIPTION_MODAL_OPENED";
    UserEventType["CHECKOUT_FORM_SUBMITTED"] = "CHECKOUT_FORM_SUBMITTED";
    UserEventType["CHECKOUT_LINK_FOLLOWED"] = "CHECKOUT_LINK_FOLLOWED";
    UserEventType["CHECKOUT_SUCCEEDED"] = "CHECKOUT_SUCCEEDED";
    UserEventType["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
    UserEventType["UPLOAD_FILE"] = "UPLOAD_FILE";
    UserEventType["UPLOAD_FILE_ERROR"] = "UPLOAD_FILE_ERROR";
    UserEventType["WRONG_FILE_TYPE_UPLOADED"] = "WRONG_FILE_TYPE_UPLOADED";
    UserEventType["WRONG_FILE_SIZE_UPLOADED"] = "WRONG_FILE_SIZE_UPLOADED";
    UserEventType["PROCESS_FILE"] = "PROCESS_FILE";
    UserEventType["PROCESS_FILE_ERROR"] = "PROCESS_FILE_ERROR";
    UserEventType["DOWNLOAD_FILE"] = "DOWNLOAD_FILE";
    UserEventType["DOWNLOAD_FILE_AS_WORD"] = "DOWNLOAD_FILE_AS_WORD";
    UserEventType["DOWNLOAD_FILE_FROM_LIST"] = "DOWNLOAD_FILE_FROM_LIST";
    UserEventType["DOWNLOAD_FILE_ERROR"] = "DOWNLOAD_FILE_ERROR";
    UserEventType["GET_UPLOADED_FILE"] = "GET_UPLOADED_FILE";
    UserEventType["UPLOAD_FILE_TO_CONVERT"] = "UPLOAD_FILE_TO_CONVERT";
    UserEventType["UPLOAD_FILE_TO_CONVERT_ERROR"] = "UPLOAD_FILE_TO_CONVERT_ERROR";
    UserEventType["CONVERT_TO_WORD"] = "CONVERT_TO_WORD";
    UserEventType["CONVERT_TO_WORD_ERROR"] = "CONVERT_TO_WORD_ERROR";
    UserEventType["DOWNLOAD_CONVERTED_TO_WORD"] = "DOWNLOAD_CONVERTED_TO_WORD";
    UserEventType["DOWNLOAD_CONVERTED_TO_WORD_ERROR"] = "DOWNLOAD_CONVERTED_TO_WORD_ERROR";
    UserEventType["PAGE_RENDER_ERROR"] = "PAGE_RENDER_ERROR";
    UserEventType["EDIT_TEXT"] = "EDIT_TEXT";
    UserEventType["ADD_TEXT"] = "ADD_TEXT";
    UserEventType["DELETE_TEXT"] = "DELETE_TEXT";
    UserEventType["ADD_TEXT_FORM"] = "ADD_TEXT_FORM";
    UserEventType["ADD_TEXTAREA_FORM"] = "ADD_TEXTAREA_FORM";
    UserEventType["ADD_SIGNATURE"] = "ADD_SIGNATURE";
    UserEventType["ADD_IMAGE"] = "ADD_IMAGE";
    UserEventType["ERASE"] = "ERASE";
    UserEventType["DRAW_PEN"] = "DRAW_PEN";
    UserEventType["DRAW_HIGHLIGHTER"] = "DRAW_HIGHLIGHTER";
    UserEventType["DRAW_RECTANGLE"] = "DRAW_RECTANGLE";
    UserEventType["DRAW_CIRCLE"] = "DRAW_CIRCLE";
    UserEventType["DRAW_LINE"] = "DRAW_LINE";
    UserEventType["DRAW_ARROW"] = "DRAW_ARROW";
    UserEventType["ADD_PAGE"] = "ADD_PAGE";
    UserEventType["DELETE_PAGE"] = "DELETE_PAGE";
})(UserEventType || (UserEventType = {}));
export var UserLogType;
(function (UserLogType) {
    UserLogType["ERROR"] = "ERROR";
    UserLogType["EVENT"] = "EVENT";
    UserLogType["ACTION"] = "ACTION";
})(UserLogType || (UserLogType = {}));
//# sourceMappingURL=types.js.map